import React, { useEffect, useRef, useState } from 'react'
import {Box, Grid, GridItem, Heading, IconButton, Image, Input, Text, Tooltip} from '@chakra-ui/react'
import CustomButton from '../../../elements/customButton'
import UploadIcon from '../../../../assets/images/upload.svg'
import DownloadIcon from '../../../../assets/images/download.png'
import CameraIcon from "../../../../assets/images/opencamicon.svg";
import { Document, Page, pdfjs } from 'react-pdf';
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActionCreators } from '../../../../redux/actions'
import CustomToast from '../../../elements/customToast'
import Loader from '../../../elements/loader'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import OnBoardInstitutionalDocuments from './OnBoradInstitutionalDocuments'
import Solo_Part_Firmsdocum from './Solo_Part_Firmsdocum'
import { pandata ,imageReader,docVerifyAi} from "../../../../utilities/OcrUtil";
import WebCamDialog from "../../../elements/webcam";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const OnBoardUploadDocuments = (props) => {

  const {addToast} = CustomToast()
  const kycState = useSelector((state) => state.kycState)
  const masterState = useSelector((state) => state.masterState)
  const [openWebCam, setOpenWebCam] = useState(false);
  const [loading, setLoading] = useState(false)
  // const [isCameraActivate, setCameraActivate] = useState(false);
  const [parsedResult, setParsedResult] = useState(null); // ← to hold the result
  const [parsedadhaarFrontResult, setParsedadhaarFrontResult] = useState(null); // ← to hold the result
  const [docVerify, setDocVerify] = useState(null); // ← to hold the result
  const refs = {
    photo: useRef(),
    pan: useRef(),
    adharFront: useRef(),
    adharBack: useRef(),
    gst: useRef(),
    rbi: useRef(),
    addressProof: useRef(),
    boardResolution: useRef(),
    cobCertificate: useRef(),
    memAssociation: useRef(),
    bankStatement: useRef(),
    incorpCertificate: useRef(),
    reg_act_certificate:useRef(),
    partnership_deed:useRef(),
    current_address_proof: useRef(),
  }
  const [fileData, setFileData] = useState({
    photo: null,
    pan: null,
    adharFront: null,
    adharBack: null,
    gst: null,
    rbi: null,
    addressProof: null,
    boardResolution: null,
    cobCertificate: null,
    memAssociation: null,
    bankStatement: null,
    incorpCertificate: null,
    partnership_deed:null,
    udyam_certificate:null,
    reg_act_certificate:null,
  })
  const [cameraPhoto,setCameraPhoto] =useState(null)
  const [camerafileData,setCamerafileData] =useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const isReject = props?.userData?.document_data?.doc_approval_status === 1
  const rejectData = (props?.userData?.user_document_checked_data?.document && JSON.parse(props?.userData?.user_document_checked_data?.document))

  useEffect(() => {
    let documentData = {
      photo: props?.userData?.photo,
      pan: props?.userData?.document_data?.pan_card,
      adharFront: props?.userData?.document_data?.aadhaar_front,
      adharBack: props?.userData?.document_data?.aadhaar_back,
      gst: props?.userData?.document_data?.gst_registration_certificate,
      rbi: props?.userData?.document_data?.rbi_licence_copy,
      boardResolution: props?.userData?.document_data?.board_resolution,
      cobCertificate: props?.userData?.document_data?.cob_certificate,
      memAssociation: props?.userData?.document_data?.mem_art_association,
      bankStatement: props?.userData?.document_data?.bank_statement_1,
      incorpCertificate: props?.userData?.document_data?.incorp_certificate,
      addressProof: props?.userData?.document_data?.additional_address_proof,
      partnership_deed: props?.userData?.document_data?.partnership_deed,
      udyam_certificate: props?.userData?.document_data?.udyam_certificate,
      reg_act_certificate: props?.userData?.document_data?.reg_act_certificate,
      current_address_proof:props?.userData?.document_data?.current_address_proof,
      is_photo_verified:props?.userData?.document_data?.is_photo_verified,
      mobile:props?.userData?.mobile,
    }
    setFileData(documentData)
  }, [props?.userData?.document_data])

  useEffect(() => {
    if (kycState?.saveDocs?.data?.success === true){
      addToast({message: kycState?.saveDocs?.data?.message, status: 'success'})
      props?.actions?.cleanUpToast()
      props?.actions?.getCPUserDetailsByIdAction({user_id: props?.userData?.id})
      props.onClick()
    } else if (kycState?.saveDocs?.data?.success === false){
      addToast({message: kycState?.saveDocs?.data?.message, status: 'error'})
    }
  }, [kycState?.saveDocs])

  const showOpenFileDialog = (type) => {
    refs[type]?.current?.click()
  }

  // const onChangeFile = (e, type) => {
  //   setFileData({ ...fileData, [type]: e.target.files[0]})
  //   setPageNumber(1)
  // }
  const getcamara = () => {
    setOpenWebCam(true)
  };
  const handleImageUpload = (formData,imageData) => {
    setCameraPhoto(formData)
    setCamerafileData(imageData)
    // setFileData(imageData)
  };
  const onChangeFile = async (e, type) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    setLoading(true);
  
    try {
      setFileData(prev => ({ ...prev, [type]: file }));
  
      if (type === 'pan' || type === 'adharFront') {
        const data = await imageReader(file); // This must return parsed data
        if ( type === 'pan' && data) {
        setLoading(true)
          setParsedResult(data);
          setPageNumber(1);
        }
        
        
        if ( type === 'adharFront' && data) {
          setLoading(false)
          setParsedadhaarFrontResult(data);
          setPageNumber(1);
        }
        else {
          // alert("No data extracted from the file");
        }
      }
    } catch (error) {

      if(type === 'pan'){
        setParsedResult(null)
      }
      else if(type === 'adharFront'){
        setParsedadhaarFrontResult(null)
      }
      addToast({message:error?.message || "File parsing failed",status: "error"})

    } finally {
      setLoading(false); // Always stop loading
    }
  };
  const verifydocImage = async () => {
    if (
      !props?.userData?.personal_data ||
      props?.userData?.digilocker_request?.status === "requested" ||
      !props?.userData?.digilocker_request
    ) {
      addToast({
        message: "Please Complete Personal Details First",
        status: "error",
      });
      return;
    }
    if (!props?.userData?.bank_data) {
      addToast({
        message: "Please Complete Bank Details First",
        status: "error",
      });
      return;
    }
    const {
      photo,
      pan,
      adharFront,
      adharBack,
      current_address_proof,
      gst,
      rbi,
      addressProof,
      boardResolution,
      cobCertificate,
      memAssociation,
      bankStatement,
      incorpCertificate,
      udyam_certificate,
      reg_act_certificate,
      partnership_deed,
    } = fileData;
    if (!props?.userData?.document_data || !props?.userData?.photo) {
      if (!cameraPhoto) {
        addToast({ message: "Please Take Your Photo", status: "error" });
        return;
      }
      if (!pan) {
        addToast({ message: "Please Upload Pan Card", status: "error" });
        return;
      }
      if (!adharFront) {
        addToast({ message: "Please Upload Aadhaar Front", status: "error" });
        return;
      }
      if (!adharBack) {
        addToast({ message: "Please Upload Aadhaar Back", status: "error" });
        return;
      }
      if ( isaddress_same == 0 && !current_address_proof) {
        addToast({
          message: "Please Upload Current Address Proof",
          status: "error",
        });
        return;
      }
      if (
        props?.user?.employment_type === "4" ||
        props?.user?.employment_type === "5"
      ) {
        if (!gst) {
          addToast({
            message: "Please Upload GST Certificate",
            status: "error",
          });
          return;
        }
        if (props?.user?.employment_type === "4") {
          if (!rbi) {
            addToast({
              message: "Please Upload RBI License Copy",
              status: "error",
            });
            return;
          }
        }
        if (props?.user?.employment_type === "5") {
          if (!addressProof) {
            addToast({
              message: "Please Upload Address Proof",
              status: "error",
            });
            return;
          }
        }
        if (!boardResolution) {
          addToast({
            message: "Please Upload Board Resolution",
            status: "error",
          });
          return;
        }
        if (!cobCertificate) {
          addToast({
            message:
              "Please Upload Certificate of Commencement Of The Business",
            status: "error",
          });
          return;
        }
        if (!memAssociation) {
          addToast({
            message: "Please Upload Memorandum And Articles Of Association",
            status: "error",
          });
          return;
        }
        if (!bankStatement) {
          addToast({
            message: "Please Upload Bank Statement",
            status: "error",
          });
          return;
        }
        if (!incorpCertificate) {
          addToast({
            message: "Please Upload Certification Of Incorporation",
            status: "error",
          });
          return;
        }
      }
    
     
    }
    try {
      const formData = new FormData();
      let panFile = null;
      if (parsedResult) {
        formData.append("pan_image", parsedResult);
      } else if (props.userData?.document_data?.pan_card) {
        panFile = await imageReader(props.userData.document_data.pan_card);
        formData.append("pan_image", panFile);
      }
      
      let aadhaarFile = null;
      if (parsedadhaarFrontResult) {
        formData.append("aadhaar_image", parsedResult);

      } else if (props.userData?.document_data?.aadhaar_front) {
        aadhaarFile = await imageReader(props.userData.document_data.aadhaar_front);
        formData.append("aadhaar_image", aadhaarFile);
      }
      let userImageBlob = camerafileData;
      if (!userImageBlob && props?.userData?.photo) {
        try {
          const response = await fetch(props?.userData.photo);
          if (response.ok) {
            userImageBlob = await response.blob();
          } 
        } catch (error) {
          console.error(" Error fetching user photo blob:", error);
        }
      }
    
      if (userImageBlob) {
        const userFile = new File([userImageBlob], "user_image.png", { type: userImageBlob.type });
        formData.append("user_image", camerafileData ?? userFile);
      }
    
      setLoading(true);
      const Ai_verify_Doc = await docVerifyAi(formData);
      setDocVerify(Ai_verify_Doc);
    } catch (error) {
      setLoading(false);
      addToast({
        message: error?.message || "Something went wrong",
        status: "error",
      })}
  };
  const displayPan = () => {
    if (typeof fileData?.pan === "string") {
      return (
        <>
          {fileData?.pan && fileData?.pan.includes(".pdf") ? (
            <Box className="pdf_block">
              <Document file={fileData?.pan}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a href={fileData?.pan} download="uploaded_pan.pdf">
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image mb={4} src={fileData?.pan} className="uploaded_image kk" />
          )}
        </>
      );
    } else {
      return (
        <>
          {fileData?.pan && fileData?.pan.type === "application/pdf" ? (
            <Box className="pdf_block">
              <Document file={fileData?.pan}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a
                href={URL.createObjectURL(fileData?.pan)}
                download="uploaded_pan.pdf"
              >
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={
                fileData?.pan ? URL.createObjectURL(fileData?.pan) : UploadIcon
              }
              className={fileData?.pan ? "uploaded_image" : "upload_icon"}
            />
          )}
        </>
      );
    }
  };
  useEffect(() => {
    if (!docVerify) return;
  
    if (docVerify?.success === 'false') {
      setLoading(false);
      addToast({ message: docVerify?.message || "Verification failed", status: 'error' });
      return;
    }
  
    const isVerified = docVerify?.data?.verified === true;
    const isReal = docVerify?.data?.user_image_spoof_check?.is_real === true;
    const Face_Confidence = docVerify?.data?.user_image_spoof_check?.face_confidence === null;
  
    if (isVerified && isReal ) {
      setLoading(false);
      addToast({ message: "Document Verified Successfully", status: 'success' });
      handleNext();
    }
    else if (!isVerified && isReal) {
      setLoading(false);
      addToast({ message: "Document is not matching", status: 'warning'});
      handleNext();
    } 
    else if (!isVerified && !isReal && Face_Confidence){
      setLoading(false);
      addToast({ message: "Your Photo is not matching", status: 'warning'});

    }
  }, [docVerify]);
  

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const form_Data = new FormData();
    form_Data.append('publicUpload', file);
    setCameraPhoto(form_Data);
    setCamerafileData(file)
  };
  const displayPhoto = () => {
    if (typeof fileData?.photo === "string" && props?.userData?.personal_data?.is_photo_verified==1 && !cameraPhoto)  {
      return <Image mb={4} src={fileData?.photo} className="uploaded_image" />
    } else {
      return (
        <Image
          mb={4}
          src={
            camerafileData ? URL.createObjectURL(camerafileData) : props?.userData?.photo 
          }
          className={(camerafileData || props?.userData?.photo )? "uploaded_image" : "upload_icon"}
        />
      );
    }
  };
  const capturePan = () => (
    <Box mb={4}>
      <Text fontWeight="bold" mb={2}>
        Your Pan photo
      </Text>
      <Image
        mb={4}
        src={URL.createObjectURL(parsedResult) || UploadIcon}
        className={
          fileData?.pan ? "uploaded_image" : "upload_icon"
        }
      />
    </Box>
  );
 
  const handleNext = () => {
    const {
      photo,
      pan,
      adharFront,
      adharBack,
      current_address_proof,
      gst,
      rbi,
      addressProof,
      boardResolution,
      cobCertificate,
      memAssociation,
      bankStatement,
      incorpCertificate,
      udyam_certificate,
      reg_act_certificate,
      partnership_deed,
    } = fileData;
    let docsData = {
      photo: camerafileData ?? "",
      pan: pan ?? "",
      aadhaarFront: adharFront ?? "",
      aadhaarBack: adharBack ?? "",
      gst: gst ?? "",
      rbi: rbi ?? "",
      boardResolution: boardResolution ?? "",
      cobCertificate: cobCertificate ?? "",
      memAssociation: memAssociation ?? "",
      incorpCertificate: incorpCertificate ?? "",
      bankStatement: bankStatement ?? "",
      addressProof: addressProof ?? "",
      udyam_certificate: udyam_certificate ?? "",
      partnership_deed: partnership_deed ?? "",
      employment_type: props?.userData?.employment_type,
      reg_act_certificate: reg_act_certificate ?? "",
      company_buss_sector: props?.userData?.personal_data?.company_buss_sector,
      current_address_proof: current_address_proof ?? "",
      mobile:props?.userData?.mobile,
      is_photo_verified:(docVerify?.data?.verified === true && docVerify?.data?.user_image_spoof_check?.is_real === true)? 1 : 0
    };
    if (
      props?.userData?.document_data &&
      props?.userData?.document_data?.doc_approval_status === 1
    ) {
      props.actions.saveDocsAction(docsData);
    } else if (!props?.userData?.document_data) {
      props.actions.saveDocsAction(docsData);

    } else if (
      props?.userData?.document_data &&
      props?.userData?.document_data?.doc_approval_status === 0
    ) {
      props.onClick();
    }
  };
  const captureAadhaarFront = () => (
    <Box mb={4}>
      <Text fontWeight="bold" mb={2}>
       Your Aadhaar photo
      </Text>
      <Image
        mb={4}
        src={URL.createObjectURL(parsedadhaarFrontResult) || UploadIcon}
        className={
          fileData?.adharFront ? "uploaded_image" : "upload_icon"
        }
      />
    </Box>
  );
  const displayAadhaarFront = () => {
    if (typeof fileData?.adharFront === "string") {
      return (
        <>
          {fileData?.adharFront && fileData?.adharFront.includes(".pdf") ? (
            <Box className="pdf_block">
              <Document file={fileData?.adharFront}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a href={fileData?.adharFront} download="uploaded_adharFront.pdf">
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={fileData?.adharFront}
              className="uploaded_image"
            />
          )}
        </>
      );
    } else {
      return (
        <>
          {fileData?.adharFront &&
          fileData?.adharFront.type === "application/pdf" ? (
            <Box className="pdf_block">
              <Document file={fileData?.adharFront}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a
                href={URL.createObjectURL(fileData?.adharFront)}
                download="uploaded_adharFront.pdf"
              >
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={
                fileData?.adharFront
                  ? URL.createObjectURL(fileData?.adharFront)
                  : UploadIcon
              }
              className={
                fileData?.adharFront ? "uploaded_image" : "upload_icon"
              }
            />
          )}
        </>
      );
    }
  };
  const displayAadhaarBack = () => {
    if (typeof fileData?.adharBack === "string") {
      return (
        <>
          {fileData?.adharBack && fileData?.adharBack.includes(".pdf") ? (
            <Box className="pdf_block">
              <Document file={fileData?.adharBack}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a href={fileData?.adharBack} download="uploaded_adharBack.pdf">
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={fileData?.adharBack}
              className="uploaded_image"
            />
          )}
        </>
      );
    } else {
      return (
        <>
          {fileData?.adharBack &&
          fileData?.adharBack.type === "application/pdf" ? (
            <Box className="pdf_block">
              <Document file={fileData?.adharBack}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a
                href={URL.createObjectURL(fileData?.adharBack)}
                download="uploaded_adharBack.pdf"
              >
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={
                fileData?.adharBack
                ? URL.createObjectURL(fileData?.adharBack)
                : UploadIcon
              }
              className={fileData?.adharBack ? "uploaded_image" : "upload_icon"}
            />
          )}
        </>
      );
    }
  };
  const displayCurrentAddrrssProof = () => {
    if (typeof fileData?.current_address_proof === "string") {
      return (
        <>
          {fileData?.current_address_proof &&
          fileData?.current_address_proof.includes(".pdf") ? (
            <Box className="pdf_block">
              <Document file={fileData?.current_address_proof}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a
                href={fileData?.current_address_proof}
                download="uploaded_current_address_proof.pdf"
              >
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={fileData?.current_address_proof}
              className="uploaded_image"
            />
          )}
        </>
      );
    } else {
      return (
        <>
          {fileData?.current_address_proof &&
          fileData?.current_address_proof.type === "application/pdf" ? (
            <Box className="pdf_block">
              <Document file={fileData?.current_address_proof}>
                <Page pageNumber={pageNumber} className="preview_pdf" />
              </Document>
              <a
                href={URL.createObjectURL(fileData?.current_address_proof)}
                download="uploaded_current_address_proof.pdf"
              >
                <IconButton
                  className="icon_button"
                  icon={<Image src={DownloadIcon} className="download-link" />}
                />
              </a>
            </Box>
          ) : (
            <Image
              mb={4}
              src={
                fileData?.current_address_proof
                  ? URL.createObjectURL(fileData?.current_address_proof)
                  : UploadIcon
              }
              className={
                fileData?.current_address_proof
                  ? "uploaded_image"
                  : "upload_icon"
              }
            />
          )}
        </>
      );
    }
  };
  const handleCloseWebCam = () => {
    setOpenWebCam(false)
  }
  const empStatus = props?.userData?.employment_type;
  const isaddress_same =
    props?.userData?.personal_data?.is_current_address_same;
  return (
    <>
    {(kycState?.saveDocs?.loading || masterState?.getCurrentUserDetails?.loading || loading)  &&
      <div>
        <Loader />
      </div>
      }
      <Box className='main_Kyc_form_container'>
        <Grid className="documents_grid_container" mb={7} mt={7}>
          <GridItem>
        <Box className='form_kyc_cp'>
          <Heading as="h1" className="font-poppins label_heading" mb={1}>
            Photo
          </Heading>

          <Box className='upload_container'>
            {displayPhoto()}
            <div className="mb-2">
              <CustomButton
                className="btn_theme font-poppins "
                title={ camerafileData ? 'Re-Upload Photo' :'Browse'}
                onClick={() => document.getElementById("upload-input").click()}
              />
              <input
                type="file"
                id="upload-input"
                accept="image/*"
                style={{ display: "none"}}
                onChange={handleFileUpload}
              />
            </div>

            <div className="mb-2 take_Cam">
              <CustomButton
                className="btn_theme font-poppins "
                title='Take a Photo'
                onClick={() => getcamara()}
              />
              <Heading mt={4} as="p" style={{ marginLeft: "112px" }} className="font-poppins note">
                {camerafileData?.name ?? ""}
              </Heading>
            </div>

            <WebCamDialog
        openWebCam={openWebCam}
        handleCloseWebCam={handleCloseWebCam}
        getImageUrl={handleImageUpload}
        name="captured-photo"
      />
    </Box>
  </Box>
</GridItem>
          <GridItem>
            <Box className='form_kyc_cp'>
              <Box mb={1} className='d-flex align-items-center justify-content-between reject_block'>
                <Heading as="h1" className="font-poppins label_heading">Upload PAN</Heading>
                {rejectData?.v2_pan_reject_reason &&
                  <Text className="font-poppins">Admin Comment
                    <Tooltip label={rejectData?.v2_pan_reject_reason}
                      hasArrow fontSize='xs' placement='bottom-start'>
                      <InfoOutlineIcon />
                    </Tooltip>
                  </Text>
                }
              </Box>
              <Box className='upload_container'>
                {displayPan()}
                <CustomButton
                  className="btn_theme font-poppins"
                  title={fileData?.pan ? 'Re-Upload' : 'Browse'}
                  onClick={() => showOpenFileDialog('pan')}
                />
                <Input
                  size="md"
                  name="upload"
                  type="file"
                  accept="image/*"
                  onChange={(e) => onChangeFile(e, 'pan')}
                  className="d-none"
                  ref={refs?.pan}
                />
                <Heading mt={4} as="p" className="font-poppins note">
                  Supported File .png, .jpg Upto 5 MB
                </Heading>
                { parsedResult &&
                  capturePan()
                }
              </Box>
            </Box>
          </GridItem>
          <GridItem>
            <Box className='form_kyc_cp'>
              <Box mb={1} className='d-flex align-items-center justify-content-between reject_block'>
                {
                  props?.userData?.employment_type === '8' ?
                  <Heading as="h1" className="font-poppins label_heading">Upload Aadhaar Front of Promoter/ Director</Heading>
                    : 
                  <Heading as="h1" className="font-poppins label_heading">Upload Aadhaar Front</Heading>

                }
                {rejectData?.v2_aadhar_reject_reason &&
                  <Text className="font-poppins">Admin Comment
                    <Tooltip label={rejectData?.v2_aadhar_reject_reason}
                      hasArrow fontSize='xs' placement='bottom-start'>
                      <InfoOutlineIcon />
                    </Tooltip>
                  </Text>
                }
              </Box>
              <Box className='upload_container'>
                {displayAadhaarFront()}
                <CustomButton
                  className="btn_theme font-poppins"
                  title={fileData?.adharFront ? 'Re-Upload' : 'Browse'}
                  onClick={() => showOpenFileDialog('adharFront')}
                />
                <Input
                  size="md"
                  name="upload"
                  type="file"
                  accept="image/*"
                  onChange={(e) => onChangeFile(e, 'adharFront')}
                  className="d-none"
                  ref={refs?.adharFront}
                />
                <Heading mt={4} as="p" className="font-poppins note">
                  Supported File .png, .jpg Upto 5 MB
                </Heading>
                { parsedadhaarFrontResult && captureAadhaarFront()}

              </Box>
            </Box>
          </GridItem>
          <GridItem>
            <Box className='form_kyc_cp'>
              <Box mb={1} className='d-flex align-items-center justify-content-between reject_block'>
                <Heading as="h1" className="font-poppins label_heading">Upload Aadhaar Back</Heading>
                {rejectData?.v2_aadhar_reject_reason &&
                  <Text className="font-poppins">Admin Comment
                    <Tooltip label={rejectData?.v2_aadhar_reject_reason}
                      hasArrow fontSize='xs' placement='bottom-start'>
                      <InfoOutlineIcon />
                    </Tooltip>
                  </Text>
                }
              </Box>
              <Box className='upload_container'>
                {displayAadhaarBack()}
                <CustomButton
                  className="btn_theme font-poppins"
                  title={fileData?.adharBack ? 'Re-Upload' : 'Browse'}
                  onClick={() => showOpenFileDialog('adharBack')}
                />
                <Input
                  size="md"
                  name="upload"
                  type="file"
                  accept="image/*"
                  onChange={(e) => onChangeFile(e, 'adharBack')}
                  className="d-none"
                  ref={refs?.adharBack}
                />
                <Heading mt={4} as="p" className="font-poppins note">
                  Supported File .png, .jpg Upto 5 MB
                </Heading>
              </Box>
            </Box>
          </GridItem>
          {isaddress_same == 0 && (
            <GridItem>
              <Box className="form_kyc">
                <Box
                  mb={3}
                  className="d-flex align-items-center justify-content-between reject_block"
                >
                  <Heading as="h1" className="font-poppins label_heading">
                    {" "}
                    Upload Current Address
                  </Heading>
                  {rejectData?.current_address_proof_reject_reason && (
                    <Text className="font-poppins">
                      Admin Comment
                      <Tooltip
                        label={rejectData?.current_address_proof_reject_reason}
                        hasArrow
                        fontSize="xs"
                        placement="bottom-start"
                      >
                        <InfoOutlineIcon />
                      </Tooltip>
                    </Text>
                  )}
                </Box>
                <Box className="upload_container">
                  {displayCurrentAddrrssProof()}
                  <CustomButton
                    className="btn_theme font-poppins"
                    title={
                      fileData?.current_address_proof ? "Re-Upload" : "Browse"
                    }
                    onClick={() => showOpenFileDialog("current_address_proof")}
                  />
                  <Input
                    size="md"
                    name="upload"
                    type="file"
                    accept="image/*"
                    onChange={(e) => onChangeFile(e, "current_address_proof")}
                    className="d-none"
                    ref={refs?.current_address_proof}
                  />
                  <Heading mt={4} as="p" className="font-poppins note">
                    Supported File .png, .jpg Upto 5 MB
                  </Heading>
                </Box>
              </Box>
            </GridItem>
          )}
          { 
          props?.userData?.employment_type === '4' || props?.userData?.employment_type === '5' || props?.userData?.employment_type === '8'  ?
            <OnBoardInstitutionalDocuments
              refs={refs}
              fileData={fileData} isReject={isReject} rejectData={rejectData}
              userData={props?.userData} pageNumber={pageNumber}
              showOpenFileDialog={showOpenFileDialog} onChangeFile={onChangeFile}
            /> :
            null
          }
           {props?.userData?.employment_type === '6' || props?.userData?.employment_type === '7' || props?.userData?.employment_type === '10' || props?.userData?.employment_type === '9' ?
              <Solo_Part_Firmsdocum
                refs={refs}
                fileData={fileData} isReject={isReject} rejectData={rejectData}
                userData={props?.userData} pageNumber={pageNumber}
                showOpenFileDialog={showOpenFileDialog} onChangeFile={onChangeFile}
              /> :
              null
            }
        </Grid>
        
        <Box className="kyc_actions">
          <CustomButton size="md" type="submit" title="Next" className="btn_green font-poppins" onClick={verifydocImage} />
        </Box>
      </Box>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(OnBoardUploadDocuments)